<div class="sort-container" [ngClass]="{ 'templates-selected': selectedTab === 'templates' }">
    <div class="default-form-field" *ngIf="selectedTab === 'offers'">
        <mat-label>
            {{ 'OVERVIEW.SORT.PLACEHOLDER' | translate }}
        </mat-label>
        <mat-form-field appearance="outline">
            <mat-select [(value)]="selectedSort" (selectionChange)="onSortSelectionChange($event.value)">
                <mat-option *ngFor="let option of sortOptions" [value]="option.value">
                    {{ option.label | translate }}
                    <ng-container *ngIf="option.sortOrder === 'asc'">↑</ng-container>
                    <ng-container *ngIf="option.sortOrder === 'desc'">↓</ng-container>
                </mat-option>
            </mat-select>
            <mat-icon>keyboard_arrow_down</mat-icon>
        </mat-form-field>
    </div>
    <div class="default-form-field">
        <mat-label>
            {{ 'OVERVIEW.DATE_PICKER.PLACEHOLDER' | translate }}
        </mat-label>
        <mat-form-field appearance="outline">
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [max]="maxDate">
                <input matStartDate formControlName="start" [max]="range.controls.end.value" />
                <input matEndDate formControlName="end" [max]="maxDate" (ngModelChange)="triggerDate()" />
            </mat-date-range-input>
            <button
                *ngIf="range.controls.start.value && range.controls.end.value"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="resetDate()"
            >
                <mat-icon>close</mat-icon>
            </button>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-error *ngIf="range.controls.start.hasError('matDatepickerMax')">{{
                'OVERVIEW.DATE_PICKER.MAX_DATE_INVALID' | translate
            }}</mat-error>
            <mat-error
                *ngIf="
                    !range.controls.start.hasError('matDatepickerMax') &&
                    (range.controls.start.invalid || range.controls.end.invalid)
                "
                >{{ 'OVERVIEW.DATE_PICKER.INVALID_DATE' | translate }}</mat-error
            >
        </mat-form-field>
    </div>
    <div class="default-form-field">
        <mat-form-field appearance="outline">
            <input
                matInput
                [(ngModel)]="searchValue"
                (keyup.enter)="triggerSearch()"
                placeholder="{{ 'OVERVIEW.SEARCH_PLACEHOLDER' | translate }}"
            />
            <button *ngIf="searchValue" matSuffix mat-icon-button aria-label="Clear" (click)="resetSearch()">
                <mat-icon>close</mat-icon>
            </button>
            <button mat-icon-button type="button" matSuffix (click)="triggerSearch()">
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>
    </div>
</div>
